import { put, select, takeLatest } from 'redux-saga/effects';

import { types, actionCreators } from '../../redux/analytics/analytics.meta';

const getBatchContentDownload = ({ analytics }) =>
  analytics.batchContentDownload;

export function* trackContentDownloadCompleted({ payload: { url } }) {
  const now = new Date().getTime();
  const batches = yield select(getBatchContentDownload);
  let pendingBatches = [];

  for (let i = 0; i < batches.length; i++) {
    let { items, lastDownloaded } = batches[i];

    const index = items.indexOf(url);
    if (index > -1) {
      items = [...items.slice(0, index), ...items.slice(index + 1)];
      lastDownloaded = now;
    } else {
      items = [...items];
    }

    if (items.length === 0) {
      const { downloadStart, lob, pageId, isFirstBatch } = batches[i];
      const downloadTime = lastDownloaded - downloadStart;

      yield put(
        actionCreators.trackBatchContentDownloadCompleted({
          downloadTime,
          lob,
          pageId,
        })
      );

      if (
        isFirstBatch &&
        window &&
        window.performance &&
        window.performance.timing
      ) {
        const { requestStart } = window.performance.timing;
        const timeToFullPageInteractable = lastDownloaded - requestStart;
        yield put(
          actionCreators.trackFullPageInteractable({
            timeToFullPageInteractable,
            lob,
            pageId,
          })
        );
      }
    } else {
      pendingBatches.push({
        ...batches[i],
        items,
        lastDownloaded,
      });
    }
  }

  yield put(
    actionCreators.updateBatchContentDownload({
      batchContentDownload: pendingBatches,
    })
  );
}

export default function* createAnalyticsSaga() {
  yield takeLatest(
    types.CONTENT_DOWNLOAD_COMPLETED,
    trackContentDownloadCompleted
  );
}
